import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );
( function( app ) {
  const COMPONENT = {
    init: function() {},
    finalize: function() {},
    animate: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $(
            `.js-fade:not(.js-ignore),
          .js-reveal:not(.js-ignore),
          .js-fade-group`,
        ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 85%',
              scrub: 0.15,

              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },

              onEnter: () => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  $( this )
                      .find( '> *' )
                      .each( function( childKey, child ) {
                        const delay = ( childKey + 1 ) / 10;
                        child.style.setProperty( '--fade-group-delay', delay + 's' );
                      } );
                }

                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );

        $(
            `.js-fade.fade-on-load:not(.js-ignore),
          .js-reveal.fade-on-load:not(.js-ignore),
          .js-fade-group.fade-on-load`,
        ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 100%',
              scrub: 0.15,

              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },

              onEnter: () => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  $( this )
                      .find( '> *' )
                      .each( function( childKey, child ) {
                        const delay = ( childKey + 1 ) / 10;
                        child.style.setProperty( '--fade-group-delay', delay + 's' );
                      } );
                }

                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );
      }

      $( '.js-image-blur' ).each( function() {
        const wrapper = this;
        const image = wrapper.querySelector( 'img' );

        if ( !image ) return;

        let imageLoaded = false;
        let hasAnimated = false;

        gsap.set( image, {
          filter: 'blur(4px)',
          scale: 1.05,
        } );

        const animateImage = () => {
          if ( !imageLoaded || hasAnimated ) return;

          hasAnimated = true;

          gsap.to( image, {
            filter: 'blur(0px)',
            scale: 1,
            duration: 1.25,
            ease: 'power2.out',
            clearProps: 'filter',
          } );
        };

        if ( image.complete ) {
          imageLoaded = true;
        } else {
          image.addEventListener(
              'load',
              () => {
                imageLoaded = true;
                animateImage();
              },
              {once: true},
          );
        }

        ScrollTrigger.create( {
          trigger: wrapper,
          start: 'top 85%',
          once: true,
          onEnter: animateImage,
        } );
      } );

      window.addEventListener( 'load', () => {
        ScrollTrigger.refresh();
      } );
    },

    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
